import axiosService from "./AxiosService";

const aideService = {
  getAide(id) {
    return axiosService.get(`/aides/${id}`);
  },
};

export default aideService;
